import { Platform } from "@angular/cdk/platform";
import { DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { CorelyLayoutComponent } from "./layout/corely/corely-layout.component";

@Component({
	selector: "app",
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
	imports: [CorelyLayoutComponent]
})
export class AppComponent {
	_platform = inject(Platform);
	document = inject(DOCUMENT);
	firestore = inject(AngularFirestore);
	faIconLibrary = inject(FaIconLibrary);
	private route = inject(ActivatedRoute);

	constructor() {
		// Add is-mobile class to the body if the platform is mobile
		if (this._platform.ANDROID || this._platform.IOS) {
			this.document.body.classList.add("is-mobile");
		}

		// Esto añade todos los iconos de Font Awesome al bundle.
		// Lo ideal sería añadir solo los que se vayan a usar, ya que añadir todos los iconos puede aumentar el tamaño de la aplicación.
		this.faIconLibrary.addIconPacks(fas, far, fab);

		// Recoge el parámetro serialNumber de la URL y guárdalo en localStorage si existe
		this.route.queryParams.subscribe((params) => {
			const serial = params["serialNumber"];
			if (serial) {
				localStorage.setItem("serialNumber", serial);
			}
		});
	}
}
